import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-ec32ecde"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  key: 0,
  "class": "PBSearch__input"
};
var _hoisted_2 = ["value", "placeholder", "onKeydown"];
var _hoisted_3 = ["onClick"];
import { useDebounce } from "@/composables/useDebounce";

import { ref, nextTick } from 'vue';
import { onClickOutside } from '@vueuse/core';
export default {
  __name: 'Search',
  props: {
    modelValue: {
      type: String,
      "default": ""
    },
    placeholder: {
      type: String,
      "default": ""
    },
    disabled: Boolean
  },
  emits: ["update:modelValue"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var _useDebounce = useDebounce(),
      debounce = _useDebounce.debounce;
    var isVisible = ref(false);
    var searchInputRef = ref(null);
    var searchRef = ref(null);
    function showInput() {
      return _showInput.apply(this, arguments);
    }
    function _showInput() {
      _showInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _searchInputRef$value;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isVisible.value = true;
              _context.next = 3;
              return nextTick();
            case 3:
              (_searchInputRef$value = searchInputRef.value) === null || _searchInputRef$value === void 0 ? void 0 : _searchInputRef$value.focus();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _showInput.apply(this, arguments);
    }
    function handleInput(e) {
      debounce(function () {
        return emit("update:modelValue", e.target.value);
      }, 300);
    }
    function close() {
      emit("update:modelValue", "");
      isVisible.value = false;
    }
    onClickOutside(searchRef, function () {
      return isVisible.value = false;
    });
    return function (_ctx, _cache) {
      var _component_PBIcon = _resolveComponent("PBIcon");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "searchRef",
        ref: searchRef,
        "class": "PBSearch"
      }, [_createVNode(_component_PBIcon, {
        name: "search",
        w: 20,
        h: 20,
        "class": _normalizeClass(["cursor-pointer", {
          'pointer-events-none opacity-50': __props.disabled
        }]),
        onClick: showInput
      }, null, 8, ["class"]), _unref(isVisible) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_PBIcon, {
        name: "search",
        w: 18,
        h: 18
      }), _createElementVNode("input", {
        ref_key: "searchInputRef",
        ref: searchInputRef,
        value: __props.modelValue,
        type: "search",
        autofocus: "",
        placeholder: __props.placeholder,
        onInput: _cache[0] || (_cache[0] = function ($event) {
          return handleInput($event);
        }),
        onKeydown: _withKeys(close, ["esc"])
      }, null, 40, _hoisted_2), _createElementVNode("button", {
        "class": "font-semibold text-primary",
        onClick: _withModifiers(close, ["prevent"])
      }, " Hide ", 8, _hoisted_3)])) : _createCommentVNode("", true)], 512);
    };
  }
};